<!-- My Account Cashier -->
<div class="cashier_left--slider myacc-cont">
  <div class="cashier_left--container">
      <div class="icon-cancel" (click)="goBack()"></div>

    <div class="cashier_left--content">

      <div class="cashier_left--content_heading myacc-pages-hdng">
        <h2 class="heading"><p>{{'cashier.CashierHeading' | translate}}</p> <span class="back-icn" (click)="goBack()"> <small class="show-desk">✕</small><i class="icon icon-arrow-2 show-mobile"></i></span></h2>
      </div>
      <div class="myaccount_inner_wrapper">
        <div class="container-fluid">

          <!-- Myaccount Header strip -->
          <!-- <app-myaccount-header [title]="'cashier.title' | translate" [userDetails]="userDetail"></app-myaccount-header> -->
          <ng-container *ngIf="isCashierPage">
            <section class="cashier-wrapper">
              <div class="row row_blocks">

                <!-- Add Funds Card -->
                <div class="cashier-blks col-md-12">
                  <div class="card">
                    <div class="img-block">
                      <img class="card-img-top " src="{{siteUrlPath}}/{{mediaUrlPath}}/cashier_deposit.png"
                        alt="deposit">
                    </div>
                    <div class="card-body clearfix">
                      <h3 class="card-title add-funds">{{'cashier.addFundsTitle' | translate}}</h3>
                      <p class="card-text make-a-secure-deposit">{{'cashier.addFundsSnipet' | translate}}</p>
                      <div class="card-body-secure">
                        <span>{{'cashier.SSLsecure' | translate}}</span>
                        <span>{{'cashier.Instant' | translate}}</span>
                      </div>
                      <div>
                        <button class="cashierbtn cashier-depositbtn" type="button"
                          (click)="deposit()">{{'cashier.addFundsBtn' | translate}}</button>
                      </div>
                    </div>
                  </div>
                </div>


                <!-- Withdraw Card -->
                <div class="cashier-blks withdrawal-block col-md-12">
                  <div class="card">
                    <div class="img-block">
                      <img class="card-img-top" src="{{siteUrlPath}}/{{mediaUrlPath}}/cashier_withdraw.png"
                        alt="withdraw">
                    </div>
                    <div class="card-body clearfix">
                      <h3 class="card-title add-funds">{{'cashier.withdrawTitle' | translate}}</h3>
                      <p class="card-text make-a-secure-deposit">{{'cashier.withdrawSnipet' | translate}}</p>
                      <div>
                        <button *ngIf="!isRealUser || cashBalance === 0" class="cashierbtn withdrawbtn" disabled
                          type="button">{{'cashier.withdrawBtn' | translate}}</button>
                        <button *ngIf="isRealUser && cashBalance > 0" class="cashierbtn withdrawbtn" type="button"
                          (click)="withdraw()">{{'cashier.withdrawBtn' | translate}}</button>
                      </div>
                      <button class="card-text make-a-secure-deposit error withdraw-outline animated-background"
                        *ngIf="isVerifiedSkelton"></button>
                      <button
                        class="card-text make-a-secure-deposit error withdraw_btn--outline managewidraw pending-withdraw-link"
                        *ngIf="isRealUser && pendingWithDrawsAvailable>0" (click)="navigiateToPendingWithdrawls()">
                        {{'cashier.manageWithdrawals' | translate}}</button>
                      <!-- <button class="card-text make-a-secure-deposit withdraw_btn--outline error managewidraw"
                        *ngIf="cashBalance === 0 && !isRealUser && !isVerifiedSkelton">
                        {{'cashier.withdrawdepositText' | translate}}</button> -->
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </ng-container>


          <!-- Skelton loader-->
          <ng-container *ngIf="!isCashierPage">
            <section class="cashier-wrapper skelton--wrapper">
              <div class="row row_blocks">
                <div class="cashier-blks col-md-12" *ngFor="let item of [].constructor(2)">
                  <div class="card">
                    <div class="card-body clearfix">
                      <h3 class="card-title animated-background"></h3>
                      <p class="card-text animated-background"></p>
                      <div class="card-body-secure animated-background"></div>
                      <button class="cashierbtn animated-background" type="button"></button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>